import Container from "Components/Container/Container";
import React from "react";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import IMAGE_URL from "Utilities/IMAGE_URL";
import { useTranslation } from "react-i18next"; // Add this import

const About = ({ data }) => {
  const { t } = useTranslation(); // Add this line

  return (
    <section className="mt-secondary lg:mt-primary overflow-hidden">
      <Container>
        <div className="flex flex-col lg:flex-row items-center justify-center xl:w-3/4 gap-16 mx-auto relative z-[100]">
          <div className="flex-1">
            <img
              src={`${IMAGE_URL}/${data?.image}`}
              alt="About"
              className="w-full h-[500px] object-cover relative z-[100]"
            />
          </div>
          <div className="flex-1">
            <h2 className="text-4xl font-title font-s">{data?.bannerTitle}</h2>
            <p className="text-3xl my-6 text-primary">
              {data?.aboutDescription}
            </p>
            <Link className="text-primary border border-primary px-6 py-1 rounded-md mb-10 lg:mb-20 flex w-max ">
              {t("about.learnMore")}
            </Link>
            <p className="text-black  p-2 text-lg uppercase font-medium rounded-md relative flex items-center gap-2 z-[10]">
              {data?.aboutTitle}
              <span className="text-primary block p-[1px] rounded-full bg-black">
                <CaretRight size={16} />
              </span>
              <div className="hidden lg:block absolute top-1/2 -translate-y-1/2 left-[-300%] w-[500%] z-[-1]  h-14 bg-lightGray/30"></div>
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default About;
